import React from "react";
import Loading from "../../../../../shared/Loading/Loading";
import Checkbox from "../../../../../shared/Checkbox/Checkbox";
import Callout from "../../../../../shared/Callout/Callout";

const FidelityPlansCheckboxSelector = props => {
	const handleChange = eventList => {
		let fidelitiesPlansSelected = [];
		eventList.map(fidelityPlan => {
			if (fidelityPlan.checked) {
				fidelitiesPlansSelected.push(fidelityPlan.value);
			}
		});

		props.onChange({ idsFidelity: fidelitiesPlansSelected });
	};

	return (
		<div>
			<h5>Programa de fidelidade</h5>
			{props.isFetching ? <Loading /> :
			!props.isFetching && props.fidelityPlans.length ? (
				<Checkbox
					onChange={e => handleChange(e)}
					options={props.fidelityPlans.map(plan => ({
						label: plan.nameFidelity.toUpperCase(),
						value: plan.idFidelity,
						checked: props.selecteds && props.selecteds.indexOf(plan.idFidelity) > -1
					}))}
					data-action="fidelity-plans-checkbox-selector-fidelity-plans-checkbox"
				/>
			) : (
				<Callout
					show={true}
					warn
					text={
						<span>
							<strong>Nenhum programa de fidelidade encontrado no período selecionado.</strong>
						</span>
					}
				/>
			)}
		</div>
	);
};

export default FidelityPlansCheckboxSelector;
